/*
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-07-20 15:15:41
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-10-29 15:17:26
 */ 
import { axios } from '@/utils/request'
import { axios as axios2 } from '@/utils/request2'

const api = {
    person: '/app/person/',
    set_my_password: '/app/set-my-password/',
    avatar: '/app/person/portraits/',
    set_avatar: '/app/person/current-portrait/',
    get_avatar_url: '/app/person/current-portrait/?urldata'
}
export default api

export function getPerson(parameter) {
    return axios({
        url: api.person,
        method: 'get',
        params: parameter,
    })
}

export function updatePerson(parameter) {
    return axios({
        url: api.person,
        method: 'put',
        data: parameter,
    })
}

export function getSelectOptions(parameter) {
    return axios({
        url: api.person +'get-choices/',
        method: 'get',
        params: parameter,
    })
}

export function setMyPassword(parameter) {
    return axios2({
        url: api.set_my_password,
        method: 'post',
        data: parameter,
    })
}

export function getAvatarList(parameter) {
    return axios({
        url: api.avatar,
        method: 'get',
        params: parameter,
    })
}

export function getAvatarUrl(parameter) {
    return axios({
        url: api.avatar + parameter.id + '/?urldata=',
        method: 'get',
    })
}

//获取当前用户头像
export function getCurAvatarUrl(parameter) {
    return axios({
        url: api.get_avatar_url,
        method: 'get',
    })
}

//设置用户头像
export function setCurAvatar(parameter) {
    return axios({
        url: api.set_avatar,
        method: 'post',
        data: parameter,
    })
}


// WEBPACK FOOTER //
// ./src/api/account/person.js